import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { AdminApiService } from '../admin-api.service';
import { Group, Role, SystemApp, User, UserListItem } from '../models';
import { ToastModule } from 'primeng/toast';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Component({
  standalone: true,
  selector: 'app-groups-page',
  imports: [
    CommonModule,
    TranslateModule,
    TableModule,
    ButtonModule,
    DialogModule,
    MultiSelectModule,
    InputTextModule,
    DropdownModule,
    FormsModule,
    ToastModule,
  ],
  styleUrls: ['./groups.page.scss'],
  templateUrl: './groups.page.html',
})
export class GroupsPage {
  api = inject(AdminApiService);
  ms = inject(MessageService);

  systems: SystemApp[] = [];
  groups: Group[] = [];
  users: UserListItem[] = [];
  roles: Role[] = [];

  show = false;
  editId: string | null = null;
  form: any = {
    name: '',
    systemKey: '',
    description: '',
    userIds: [],
    roleIds: [],
  };
  userOptions: { label: string; value: string }[] = [];
  roleOptions: { label: string; value: string }[] = [];

  ngOnInit() {
    this.api.listSystems().subscribe((s) => (this.systems = s));

    this.api.listUsers({ page: 1, pageSize: 1000 }).subscribe((result) => {
      this.users = result.items || [];
      this.userOptions = this.users.map((u) => ({
        label: u.fullName?.trim() || u.username,
        value: u.id,
      }));
    });

    this.api.listRoles().subscribe((r) => {
      this.roles = r || [];
      this.roleOptions = this.roles
        .filter((role) => !!role.id)
        .map((role) => ({ label: role.name, value: role.id as string }));
    });

    this.load();
  }
  load() {
    this.api.listGroups().subscribe((g) => (this.groups = g));
  }

  openNew() {
    this.editId = null;
    this.form = {
      name: '',
      systemKey: '',
      description: '',
      userIds: [],
      roleIds: [],
    };
    this.show = true;
  }
  openEdit(g: Group) {
    this.editId = g.id || null;
    this.form = {
      name: g.name,
      systemKey: g.systemKey,
      description: g.description,
      userIds: [],
      roleIds: [],
    };
    this.show = true;

    if (g.id) {
      this.api.getGroupUsers(g.id).subscribe((ids) => (this.form.userIds = ids || []));
      this.api.getGroupRoles(g.id).subscribe((ids) => (this.form.roleIds = ids || []));
    }
  }

  save() {
    const userIds: string[] = this.form.userIds || [];
    const roleIds: string[] = this.form.roleIds || [];

    const req = this.editId
      ? this.api.updateGroup(this.editId, this.form)
      : this.api.createGroup(this.form);

    req.subscribe({
      next: (res: any) => {
        const gid = this.editId || (res && res.id) || null;
        if (gid) {
          this.api.setGroupUsers(gid, userIds).subscribe();
          this.api.setGroupRoles(gid, roleIds).subscribe();
        }
        this.ms.add({ severity: 'success', summary: 'تم', detail: 'تم الحفظ' });
        this.show = false;
        this.load();
      },
      error: () =>
        this.ms.add({
          severity: 'error',
          summary: 'خطأ',
          detail: 'تعذر الحفظ',
        }),
    });
  }
  remove(g: Group) {
    if (!g.id) return;
    this.api.deleteGroup(g.id).subscribe({
      next: () => {
        this.ms.add({ severity: 'success', summary: 'تم', detail: 'تم الحذف' });
        this.load();
      },
      error: () =>
        this.ms.add({
          severity: 'error',
          summary: 'خطأ',
          detail: 'تعذر الحذف',
        }),
    });
  }
}
